/**
 * Item 5 — read the user's last production listing adapter for a connection
 * from the renderer-side `databasesService` window-global. Returns
 * `undefined` when no listing has run yet (e.g. the user clicked
 * Diagnostics before opening Object Explorer).
 *
 * Two-value enum (`'driver' | 'sqltools'`), fully PII-safe. Only used by
 * the diagnostics IPC plumbing — production behaviour is unaffected.
 */

import type { DiagnosticsListingAdapter } from '../../../types/connectionDiagnostics';

export function readLastListingAdapter(
  connectionId: string
): DiagnosticsListingAdapter | undefined {
  if (typeof window === 'undefined') return undefined;
  const ns = (
    window as unknown as {
      __SLICE1_DB_SERVICES__?: {
        getLastListingAdapter?: (id: string) => DiagnosticsListingAdapter | undefined;
      };
    }
  ).__SLICE1_DB_SERVICES__;
  return ns?.getLastListingAdapter?.(connectionId);
}
